import React from 'react'
import NavBar from '../components/NavBar'
import Heroimg from '../components/Heroimg'
import Footer from '../components/Footer'
import AboutContent from '../components/AboutContent'

const Home = () => {
  return (
    <div>
      <NavBar />
      <Heroimg />
      <AboutContent />
      <Footer />
    </div>
  )
}

export default Home
